import React from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

function dateTime(value, timezone) {
  if (!value) return "";
  return new Intl.DateTimeFormat("es-AR", {
    timeZone: timezone || undefined,
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}

export default function RestaurantTableOperationDialogs({
  reservation,
  customerReservation,
  onCloseReservation,
  onCloseCustomer,
}) {
  const customer = customerReservation?.customer;
  return (
    <>
      <Dialog open={Boolean(reservation)} onClose={onCloseReservation} fullWidth maxWidth="sm">
        <DialogTitle>Reserva gastronómica</DialogTitle>
        <DialogContent dividers>
          {reservation ? (
            <Stack spacing={1.2}>
              <Typography sx={{ fontWeight: 900 }}>{reservation.customer?.fullName || "Cliente"}</Typography>
              <Typography variant="body2">
                {dateTime(reservation.startAt, reservation.timezone)} · {reservation.partySize} personas · {reservation.durationMinutes} min
              </Typography>
              <Typography variant="body2">Estado: {reservation.status || "confirmada"}</Typography>
              {reservation.customer?.phone ? <Typography variant="body2">Teléfono: {reservation.customer.phone}</Typography> : null}
              {reservation.customer?.email ? <Typography variant="body2">Email: {reservation.customer.email}</Typography> : null}
              {reservation.notes ? <><Divider /><Typography variant="body2">{reservation.notes}</Typography></> : null}
            </Stack>
          ) : null}
        </DialogContent>
        <DialogActions><Button onClick={onCloseReservation}>Cerrar</Button></DialogActions>
      </Dialog>

      <Dialog open={Boolean(customerReservation)} onClose={onCloseCustomer} fullWidth maxWidth="xs">
        <DialogTitle>Cliente de la reserva</DialogTitle>
        <DialogContent dividers>
          {customer ? (
            <Stack spacing={1}>
              <Typography sx={{ fontWeight: 900 }}>{customer.fullName || "Cliente"}</Typography>
              <Typography variant="body2">{customer.phone || "Sin teléfono"}</Typography>
              <Typography variant="body2">{customer.email || "Sin email"}</Typography>
              {customerReservation?.customerId ? (
                <Chip size="small" label="Vinculado al CRM" sx={{ alignSelf: "flex-start" }} />
              ) : (
                <Typography variant="caption" color="text.secondary">Contacto guardado dentro de esta reserva.</Typography>
              )}
            </Stack>
          ) : null}
        </DialogContent>
        <DialogActions><Button onClick={onCloseCustomer}>Cerrar</Button></DialogActions>
      </Dialog>
    </>
  );
}
